<template>
  <li
    class="nav-item b-nav-dropdown dropdown"
    id="project-dropdown"
    v-if="isProjectOpen"
    v-clickOutside="onClickedOutside"
  >
    <a
      class="dropdown-toggle nav-link-custom"
      href="#"
      id="project-DropdownMenuLink"
      data-toggle="dropdown"
      aria-haspopup="true"
      :aria-expanded="opened"
      @click.prevent="toggle"
    >
      <b-icon-book
         class="menu-icon"
        variant="light"
        height="25px"
        width="25px"
        style="margin-top: -3px" />
    </a>

    <ul
      class="dropdown-menu dropdown-menu-right"
      :class="{show : opened}"
      aria-labelledby="project-DropdownMenuLink"
    >
      <!-- current project -->
      <li role="presentation" disabled v-if="currentProject">
        <a
          role="menuitem"
          target="_self"
          tabindex="-1"
          aria-disabled="true"
          href="#"
          class="dropdown-item disabled"
        >
          {{ $t("header.project") }}
          {{ currentProject.caption }}
        </a>
      </li>
      <b-dropdown-divider></b-dropdown-divider>
      <!-- list of projects -->
      <template v-for="(project, prjIndex) in projects">
        <li
          v-if="project.branches.length > 1"
          @click.prevent="toggleExpandProject(project.name)"
          class="dropdown-submenu dropleft"
          :key="prjIndex"
        >
          <a
            class="dropdown-item-custom dropdown-toggle"
            :class="{ active: isActive(project) }"
            href="#"
            >{{ project.caption }}</a
          >
          <!-- sub-menu -->
          <ul
            class="dropdown-menu branch"
            v-if="project.name === expandedProject"
          >
            <li
              v-for="(branch, brchIndex) in project.branches"
              :key="brchIndex"
            >
              <a
                class="dropdown-item"
                :class="{ active: isActive(project, branch) }"
                href="#"
                @click="changeProject(project, branch)"
                >{{ branch.caption }}</a
              >
            </li>
          </ul>
        </li>
        <li v-else :key="prjIndex">
          <a
            class="dropdown-item"
            :class="{ active: isActive(project) }"
            href="#"
            @click="changeProject(project)"
            >{{ project.caption }}</a
          >
        </li>
      </template>
    </ul>
  </li>
</template>
<script>
//---- 3rd-parties --------
import { BIconBook } from "bootstrap-vue";
export default {
  components: {
    BIconBook,
  },
  data() {
    return {
      opened: false,
      expandedProject: null,
    };
  },
  methods: {
    async changeProject(project, branch) {

      if (!await this.checkForUnsavedAuthoringModifications())
        return;

      this.opened = false;
      var actionStartTime = new Date().getTime();

      const reqData = new FormData();
      reqData.append("projectName", project.name);
      if (branch) reqData.append("branchName", branch.name);
      reqData.append("actionStartTime", actionStartTime);
      reqData.append("actionCategory", "selectProject");

      this.$store.dispatch("projectData/openProject", reqData);
    },

    toggleExpandProject(projectName) {
      if (this.expandedProject === projectName) {
        this.expandedProject = null;
      } else this.expandedProject = projectName;
    },
    toggle() {
      this.opened = !this.opened;
    },
    hideDropDown() {
      this.opened = false;
    },
    hideBranchSubMenu() {
      this.expandedProject = null;
    },
    onClickedOutside() {
      this.opened = false;
      this.expandedProject = null;
    },
    isActive(project, branch) {
      if (!branch)
        return (project.name === this.currentProject?.name);
      else
        return (project.name === this.currentProject?.name && branch.name === this.currentBranch?.name);
    },
    // method required for the directive
    popupClosed() {
      return !this.opened;
    },
  },
  directives: {
    clickOutside: {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // only execute the rest if popup is opened
          if (vnode.context["popupClosed"]()) return;
          // here I check that click was outside the el and his childrens
          if (!(el == event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.body.removeEventListener("mouseup", el.clickOutsideEvent);
        document.body.addEventListener("mouseup", el.clickOutsideEvent);
      },
      unbind(el) {
        document.body.removeEventListener("mouseup", el.clickOutsideEvent);
      },
    },
  },
  computed: {
    projects() {
      return this.$store.getters["header/projects"];
    },
    isProjectOpen() {
      return this.$store.getters["projectData/isProjectOpen"];
    },
    currentProject() {
      return this.$store.getters["header/currentProject"];
    },
    currentBranch() {
      if (!this.currentProject)
        return undefined;
      return this.currentProject?.branches.find(branch => branch.isCurrentBranch);
    },

  },
};
</script>
<style scoped>
a.dropdown-item.active {
  color: #fff;
  text-decoration: none;
  background-color: #007bff;
}
ul.branch {
  display: block;
}
.dropdown-submenu {
  position: relative;
}
.dropdown-item-custom.active {
  background-color: #e4e7ff;
}
.dropdown-submenu > .dropdown-menu {
  top: 0;
  right: 95%;
  margin-top: -6px;
}
nav {
  width: auto !important;
}
.nav-link-custom {
  color: rgba(255, 255, 255, 0.5);
  padding: 0px 5px;
}
.nav-link-custom:hover {
  color: rgba(255, 255, 255, 0.75);
}
.nav-item {
  width: 50px !important;
}
.dropdown-item-custom {
  display: block;
  width: 100%;
  padding: 0.25rem 1rem;
  clear: both;
  font-weight: 400;
  text-align: inherit;
  white-space: nowrap;
  border: 0;
  color: #16181b;
  text-decoration: none;
}
.dropdown-menu {
  float: left !important;
}
</style>